export const Condition0Type: Record<string, boolean> = {};
export const Condition1Type: Record<string, boolean> = {};
export const Condition2Type: Record<string, boolean> = {};
